export enum ContextType {
  EPG = 'epg',
  MAIN = 'main',
  MOSAIC = 'mosaic',
}
